import { lazy, Suspense } from 'react';

import { Loading } from '../../components/ui.jsx';

/**
 * Running the install in the web app: the setup wizard (bare), the generated settings pages, the
 * activity log, bans and the System page, all in the admin sidebar's System section.
 */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const settings = () => import('./Settings.jsx');
const activity = () => import('./Activity.jsx');
const bans = () => import('./Bans.jsx');
const health = () => import('./SystemHealth.jsx');
const setup = () => import('./Setup.jsx');
const retention = () => import('./Retention.jsx');

const ClientActivityTab = (() => {
  const Lazy = lazy(() => activity().then((m) => ({ default: m.ClientActivityTab })));
  return function Deferred(props) {
    return (
      <Suspense fallback={<Loading />}>
        <Lazy {...props} />
      </Suspense>
    );
  };
})();

export default {
  name: 'system',
  publicRoutes: [{ path: 'setup', bare: true, lazy: page(setup, 'Setup') }],
  adminRoutes: [
    { path: 'settings', lazy: page(settings, 'SettingsIndex') },
    { path: 'settings/:category', lazy: page(settings, 'SettingsCategory') },
    { path: 'activity', lazy: page(activity, 'ActivityLog') },
    { path: 'bans', lazy: page(bans, 'Bans') },
    { path: 'system', lazy: page(health, 'SystemHealth') },
    { path: 'retention', lazy: page(retention, 'Retention') },
  ],
  adminNav: [
    {
      section: 'system',
      to: '/admin/settings',
      label: 'Settings',
      permission: 'admin.settings.general.read',
      order: 1,
    },
    { section: 'system', to: '/admin/activity', label: 'Activity log', permission: 'admin.activity.read', order: 50 },
    { section: 'system', to: '/admin/bans', label: 'Bans', permission: 'admin.bans.manage', order: 60 },
    {
      section: 'system',
      to: '/admin/retention',
      label: 'Data retention',
      permission: 'admin.settings.other.read',
      order: 70,
    },
    { section: 'system', to: '/admin/system', label: 'System', permission: 'admin.system.health', order: 90 },
  ],
  adminClientTabs: [
    { key: 'log', label: 'Log', order: 95, permission: 'admin.activity.read', Component: ClientActivityTab },
  ],
};
